<template>
  <div id="app" translate="no">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>
